import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/Home';
import Assessment from './pages/Assessment';
import Results from './pages/Results';
import GuestResults from './pages/GuestResults';
import Dashboard from './pages/Dashboard';
import About from './pages/About';
import Login from './pages/Login';
import Register from './pages/Register';
import Admin from './pages/Admin';
import './App.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/assessment" element={<Assessment />} />
          <Route path="/guest-results" element={<GuestResults />} />
          <Route path="/results" element={<ProtectedRoute>
            <Results />
          </ProtectedRoute>} />
          <Route path="/dashboard" element={<ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>} />
          <Route path="/admin" element={<AdminProtectedRoute>
            <Admin />
          </AdminProtectedRoute>} />
          <Route path="/about" element={<About />} />
        </Routes>
      </div>
    </Router>
  );
}

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated');
  
  useEffect(() => {
    if (!isAuthenticated) {
      window.location.hash = '/login';
    }
  }, [isAuthenticated]);

  return isAuthenticated ? (
    <main>{children}</main>
  ) : null;
};

const AdminProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  
  useEffect(() => {
    if (!isAuthenticated || user.role !== 'admin') {
      window.location.hash = '/login';
    }
  }, [isAuthenticated, user.role]);

  return isAuthenticated && user.role === 'admin' ? (
    <main>{children}</main>
  ) : null;
};

export default App;